interface IData {
  [propName: string]: any;
}

interface IRes {
  errno?: number;
  errmsg?: string;
  data?: any;
  [propName: string]: any;
}

interface IOptions {
  url: string;
  timeout?: number;
  data: IData;
  isCom?: boolean;
}

function formatParams(data: IData) {
  const arr = [];
  for (const name in data) {
    if (data.hasOwnProperty(name)) {
      arr.push(`${encodeURIComponent(name)}=${encodeURIComponent(data[name])}`);
    }
  }
  return arr.join("&");
}

const jsonp = (options: IOptions): Promise<any> => {
  return new Promise((resolve, reject) => {
    options = options || {};
    if (!options.url) {
      reject(new Error("参数不合法"));
    }
    let timer: number;
    const callbackName = ("jsonp_" + Math.random()).replace(".", "");

    const head = document.querySelector("head") as Element;
    if (options.isCom) {
      options.data.jsonp = callbackName;
    } else {
      options.data.callback = callbackName;
    }

    const params = formatParams(options.data);
    const script = document.createElement("script");

    script.src = options.url + "?" + params;

    head.appendChild(script);

    window[callbackName] = (res: IRes) => {
      head.removeChild(script);
      clearTimeout(timer);
      window[callbackName] = null;
      resolve(res);
    };

    if (options.timeout) {
      timer = window.setTimeout(() => {
        window[callbackName] = null;
        head.removeChild(script);
        reject(new Error("网络超时"));
      }, options.timeout);
    }
  });
};

export const jsonp2 = (options: IOptions): Promise<any> => {
  return new Promise((resolve, reject) => {
    options = options || {};
    if (!options.url) {
      reject(new Error("参数不合法"));
    }
    let timer: number;
    const callbackName = ("jsonp_" + Math.random()).replace(".", "");

    const head = document.querySelector("head") as Element;
    if (options.isCom) {
      options.data.jsonp = callbackName;
    } else {
      options.data.callback = callbackName;
    }

    const params = formatParams(options.data);
    const script = document.createElement("script");

    script.src = options.url + "?" + params;

    head.appendChild(script);

    window[callbackName] = (res: IRes) => {
      resolve(res);
      head.removeChild(script);
      clearTimeout(timer);
      window[callbackName] = null;
    };

    window.timeout = () => {
      resolve({});
      window[callbackName] = null;
      head.removeChild(script);
    };

    if (options.timeout) {
      timer = window.setTimeout(() => {
        resolve({});
        window[callbackName] = window.timeout;
        //
      }, options.timeout);
    }
  });
};

export default jsonp;
